import styled from 'styled-components'

export const Container = styled.table`
width: 100%;
height: fit-content;
padding: .75rem;
border-spacing: 0 .25rem;
font-family: 'Roboto','sans-serif';
thead{
    tr{
        font-weight: 700;
        font-size: 0.875rem;
    }

    th:first-child{
        padding-left: 2rem;
        text-align: start;
    }
    th:last-child{
        text-align: end;
        padding-right: 2rem;
    }
}

tbody{
    tr{
        font-weight: 500;
        font-size: 0.875rem;
        th:first-child{
            padding-left: 2rem;
            text-align: start;
        }

        th:last-child{
            font-weight: 700;
            font-size: 0.875rem;
            text-align: right;
            padding-right: 2rem;
        }
    }

    tr:nth-child(odd) {
        background-color: #CC42A215;
    }

    tr,th{
        border-collapse: collapse;
        padding: .5rem;
    }
}
`
